var React = require('react');

function XTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.2,1.5h2.2L9.6,7l5.7,7.5h-4.4L7.3,10l-4,4.5H1.1l5.2-5.9L0.8,1.5h4.5l3.1,4.2L12.2,1.5z M11.4,13.2h1.2L4.7,2.8H3.4\n\tL11.4,13.2z"}));
}

XTwitter.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = XTwitter;

XTwitter.default = XTwitter;
